/* global $, ShopgateProductDetailsCore */

/**
 * This ShopgateProductDetailsCore plugin provides the functionality to put and remove
 * products on and from the customers favourite list.
 * @param  {Object} _core Reference to the ShopgateProductDetailsCore
 * @return {Object} An object with informations about the capabilities of this plugin
 */
var favouriteListPlugin = function(_core, _coreOptions) {
	var FAVOURITE_LIST_ITEM_ADDED = 'Added';
	var FAVOURITE_LIST_ITEM_REMOVED = 'Removed';

  var onlyPutParentProductsOnTheList = false;
  var pluginUrls = null;
  var $scope = null;
  var $favouriteListButton = null;
  var $favouriteListButtonLabel = null;
  var $favouriteListButtonSign = null;
  var $favouriteListBadge = null;

  /**
   * Called before the core is completely initialized
   * @param  {String} callType The type of the function call (products.ui or products.data)
   * @param  {Object} data Useful data {products, coreOptions}
   */
  function _onCoreInit(callType, data) {
    pluginUrls = _core.getComponentUrls('favourite_list');

    // pick the right function for the current call type
    if (callType && callType == 'products.data') {
      onCoreInitData(data);
    } else if (callType && callType == 'products.ui') {
      onCoreInitUI(data);
    }
  }

  /**
   * Initialize the data of the favourite list
   * @param  {Object} data The data passed to the onCoreInit function
   */
  function onCoreInitData(data) {
    // create an object for the favourite list if not already present
    if (typeof _core.products.favourite == 'undefined') {
      _core.products.favourite = {};
    }

    $(document).bind('shopgateFramework.dataUpdate.favouriteList', function (e, data) {
      if (data && ((data.guid && data.guid != _core.getGUID()) || !data.guid)) {
        checkResponse(data.data, false);
      }
    });

    // init necessary states for the favourite list
    _core.setState('favouriteListButtonBusy', false);
    _core.setState('favouriteListProductOnList', false);

    // ############################################################
    // Inject some functions into the core for the favourite list
    // ############################################################

    /**
     * Called by the plugins if the favourite list button should be updated
     */
    _core.updateFavouriteListButton = function (broadcastUpdate) {
      var favouriteListEntriesCounter = 0;

      _core.setState('favouriteListButtonBusy', false);

      // Try get the stored favourite list data and then update the button (in app)
      if (_coreOptions.isApp) {
        var favListData = JSON.parse(window.localStorage.getItem('favouriteListData'));
        if (favListData && typeof favListData === 'object') {
          _core.products.favourite = favListData;
        }
      }

      _updateFavouriteListButton();

      function _updateFavouriteListButton() {
        // check if there are favourite list entries present in the core
        if (typeof _core.products.favourite != 'undefined') {
          var selectedProduct = onlyPutParentProductsOnTheList ? _core.getParentProduct() : _core.getSelectedProduct();
          var productOnList = false;
          var atLeastOneChildProductOnList = false;

          // check if the current selected product is on the list
          for (var favouriteListEntryId in _core.products.favourite) {
            var favouriteListEntry = _core.products.favourite[favouriteListEntryId];

            // Count favourite items (where product data is available)
            if (favouriteListEntry.product) {
              favouriteListEntriesCounter++;
            }

            if (favouriteListEntry.favourite_list_entry && favouriteListEntry.favourite_list_entry.product_id == selectedProduct.product.id) {
              productOnList = true;
            }

            // check if there is at least one
            if (favouriteListEntry.product && _core.isChildProduct(_core.getProductByProductId(favouriteListEntry.product.id))) {
              atLeastOneChildProductOnList = true;
            }
          }

          // if none of the child products has an entry in the favourite list we search for an entry for the parent product.
          // if we found it on the list, every single child product will be flagged.
          if (!_core.isStepByStepMode() && !atLeastOneChildProductOnList && _core.parentProductHasChildProducts()) {
            if (_getFavouriteListEntryIdForParentProduct()) {
              productOnList = true;
            }
          }

          // Try to call the custom event to update the favourite list icon in the navigationbar (in app)
          try {
            if (typeof SGEvent.Broadcast.updateFavouriteListIcon != 'undefined' && pageInformation.visible) {
              SGEvent.Broadcast.updateFavouriteListIcon({
                favouriteListProductOnList: productOnList,
                identifier: pageInformation.tab
              });
            }
          } catch (e) {
          }

          _core.setState('favouriteListProductOnList', productOnList, true);

          // if the core isn't inizialized yet we have to perform the state update manually
          if (_core.isInitialized() === false) {
            var states = _core.getStates();

            _onUpdateStates('products.ui', {
              favouriteListButtonBusy: states.favouriteListButtonBusy,
              favouriteListProductOnList: states.favouriteListProductOnList
            });
          }
        }

        // update the badge
        _core.callPlugins('onUpdateFavouriteListBadge', {
          counter: favouriteListEntriesCounter,
          broadcast_update: broadcastUpdate
        });

      }
    };

    /**
     * Checks if there is a favourite list entry for the parent product on the favourite list.
     * @returns null|int The favouriteListEntryId if the parent product list entry or NULL
     */
    function _getFavouriteListEntryIdForParentProduct() {
      var parentProduct = _core.getParentProduct();
      var matchingFavouriteListEntryId = null;

      for (var favouriteListEntryId in _core.products.favourite) {
        var favouriteListEntry = _core.products.favourite[favouriteListEntryId];

        if (parentProduct && favouriteListEntry.product && favouriteListEntry.product.id == parentProduct.product.id) {
          matchingFavouriteListEntryId = favouriteListEntry.favourite_list_entry.id;
          break;
        }
      }

      return matchingFavouriteListEntryId;
    }

    /**
     * Called if the current product should be added to the favourite list
     */
    _core.addProductToFavouriteList = function () {
      if (!pluginUrls.add_to_list) {
        console.warn('addProductToFavouriteList: no valid url for ajax request passed');
        return false;
      }

      _core.setState('favouriteListButtonBusy', true);

      var selectedProduct = onlyPutParentProductsOnTheList ? _core.getParentProduct() : _core.getSelectedProduct();

			// perform the ajax request
			_core.ajax({
				url: pluginUrls.add_to_list + '/' + selectedProduct.product.id,
				complete: function () {
					_core.setState('favouriteListButtonBusy', false);
				},
				success: function (response) {
					_ajaxSuccessCallback(response, FAVOURITE_LIST_ITEM_ADDED, selectedProduct.product);
				}
			});
		};

    /**
     * Called if the current product should be removed from the favourite list
     */
    _core.removeProductFromFavouriteList = function () {
      if (!pluginUrls.remove_from_list) {
        console.warn('removeProductFromFavouriteList: no valid url for ajax request passed');
        return false;
      }

      var selectedProduct = onlyPutParentProductsOnTheList ? _core.getParentProduct() : _core.getSelectedProduct();
      var matchingFavouriteListEntryId = null;

      // search for the selected product in the favourite list entries to get the list id
      for (var favouriteListEntryId in _core.products.favourite) {
        if (_core.products.favourite[favouriteListEntryId].favourite_list_entry.product_number == selectedProduct.product.product_number) {
          matchingFavouriteListEntryId = favouriteListEntryId;
          break;
        }
      }

      // none of the child products is on the list. perhaps we can find the parent product in the list and remove that
      if (!matchingFavouriteListEntryId && _core.parentProductHasChildProducts()) {
        matchingFavouriteListEntryId = _getFavouriteListEntryIdForParentProduct();
      }

      if (matchingFavouriteListEntryId) {
        _core.setState('favouriteListButtonBusy', true);

				_core.ajax({
					url: pluginUrls.remove_from_list + '/' + matchingFavouriteListEntryId,
					complete: function () {
						_core.setState('favouriteListButtonBusy', false);
					},
					success: function (response) {
						_ajaxSuccessCallback(response, FAVOURITE_LIST_ITEM_REMOVED, selectedProduct);
					}
				});
			}
		};

		/**
		 * Is called when the ajax request to the server for add/remove succeeded
		 *
		 * @param response    Response object
		 * @param mode		  Either 'Added' or 'Removed'
		 * @param productData Product data for the product that was added or removed
		 *
         * @private
         */
		function _ajaxSuccessCallback(response, mode, productData) {
			if (typeof response != 'undefined' && response.success) {
				checkResponse(response.data, true);

				$(document).trigger('shopgateFramework.dataUpdate.favouriteListItem' + mode, [{
					product: productData
				}]);
			} else {
				try {
					if(typeof SGEvent.Broadcast.updateFavouriteListIcon != 'undefined' && pageInformation.visible){
						SGEvent.Broadcast.updateFavouriteListIcon({favouriteListProductOnList: _core.getStates().favouriteListProductOnList, identifier: pageInformation.tab });
					}
				} catch(e){}
			}
		}

    function checkResponse(responseData, broadcastUpdate) {
      var tmpList = {};

      broadcastUpdate = broadcastUpdate || false;

      function _addEntryToTmpList(newEntry) {
        if (newEntry.favourite_list_entry) {
          tmpList[newEntry.favourite_list_entry.id] = newEntry;
        }
      }

      // check if the response is valid. reponse can be an array or an object
      if (Array.isArray(responseData)) {
        for (var favouriteListEntryIndex = 0; favouriteListEntryIndex < responseData.length; favouriteListEntryIndex++) {
          _addEntryToTmpList(responseData[favouriteListEntryIndex]);
        }
      } else if (typeof responseData == 'object') {
        for (var favouriteListEntryId in responseData) {
          _addEntryToTmpList(responseData[favouriteListEntryId]);
        }
      }

      _core.products.favourite = tmpList;

      // Try to store the favourite list data (in app)
      if (_coreOptions.isApp) {
        window.localStorage.setItem('favouriteListData', JSON.stringify(_core.products.favourite));
      }

      // update button, sets state to false
      _core.updateFavouriteListButton(broadcastUpdate);
    }
  }

  /**
   * Initialize the UI of the favourite list
   * @param  {Object} data The data passed to the onCoreInit function
   */
  function onCoreInitUI(data) {
    $scope = $('#content > .product');
    $favouriteListButton = $('.favourite-list', $scope);
    $favouriteListButtonLabel = $('#favourite-list-label', $scope);
    $favouriteListButtonSign = $('.favourite-list-sign', $scope);
    $favouriteListBadge = $('.favourite-list-badge');
  }

  /**
   * Called when the core has collected data to display a new product
   * @param  {String} callType The type of the function call (products.ui or products.data)
   * @param  {[type]} productData Useful data for this function {is_parent_product, parent_product_id, product, product_attributes, product_input_fields, product_options}
   */
  function _onUpdateProduct(callType, productData) {
    if (callType && callType != 'products.ui') {
      return false;
    }

    if (typeof _core.updateFavouriteListButton == 'function') {
      _core.updateFavouriteListButton();
    }
  }

  $(document).bind('shopgateFramework.updateFavouriteListIcon', function () {
    _onUpdateProduct('products.ui');
  });

  /**
   * Called if the favourite list states have changed
   * @param  {String} callType The type of the function call (products.ui or products.data)
   * @param  {Object} currentStates The current core states
   */
  function _onUpdateStates(callType, currentStates) {
    if (callType && callType != 'products.ui') {
      return;
    }

    // process the button busy state
    if (typeof currentStates.favouriteListButtonBusy != 'undefined') {
      if (currentStates.favouriteListButtonBusy === true) {
        $favouriteListButton.addClass('disabled loading');
      } else {
        $favouriteListButton.removeClass('disabled loading');
      }
    }

    // process the product on list state
    if (typeof currentStates.favouriteListProductOnList != 'undefined') {

      if (currentStates.favouriteListProductOnList === true) {
        // the current product is on the favourite list
        $favouriteListButtonLabel._t('favourite_button_on_list');

        let $icon = $favouriteListButton
          .find('.sg-heart-o')
          .removeClass('sg-heart-o')
          .addClass('sg-heart');

        // redraw-fix will cause the browser to redraw the element
        // some devices and older webkit versions fail to redraw if icon changes
        setTimeout(() => {
          $icon.toggleClass('redraw-fix');
        }, 10);

        $favouriteListButtonSign
          .removeClass('add')
          .addClass('delete')
          .html('&minus;');

        $favouriteListButton.unbind('click').click(() => {
          _core.removeProductFromFavouriteList();
        });
      } else {
        // the current product is NOT on the favourite list
        $favouriteListButtonLabel._t('favourite_button_not_on_list');

        let $icon = $favouriteListButton
          .find('.sg-heart')
          .removeClass('sg-heart')
          .addClass('sg-heart-o');

        // redraw-fix will cause the browser to redraw the element
        // some devices and older webkit versions fail to redraw if icon changes
        setTimeout(() => {
          $icon.toggleClass('redraw-fix');
        }, 10);

        $favouriteListButtonSign.removeClass('delete').addClass('add').text('+');

        $favouriteListButton.unbind('click').click(() => {
          _core.addProductToFavouriteList();
        });
      }
    }
  }

  /**
   * Called if the badge for the favourite list needs an update
   * @param  {String} callType The type of the function call (products.ui or products.data)
   * @param  {Number} favouriteListEntriesCounter The current count of favourite list entries
   */
  function _onUpdateFavouriteListBadge(callType, data) {
    if (callType && callType != 'products.ui') {
      return;
    }

    data.counter = (_core.isNumeric(data.counter) && parseInt(data.counter) !== 0) ? parseInt(data.counter) : 0;

    // check if the passed value is valid and greater than 0
    if (data.counter) {
      $favouriteListBadge.text(data.counter);
    } else {
      $favouriteListBadge.empty();
    }

    if (data.broadcast_update) {
      $(document).trigger('shopgateFramework.dataUpdate.favouriteList', [{
        badge_counter: data.counter,
        data: typeof _core.products.favourite !== 'undefined' ? _core.products.favourite : {},
        guid: _core.getGUID()
      }]);
    }
  }

  var hooks = {
    vendor: 'Shopgate',
    name: 'ShopgateFavouriteList',
    type: ['products.ui', 'products.data'],
    onCoreInit: _onCoreInit,
    onUpdateProduct: _onUpdateProduct,
    onUpdateStates: _onUpdateStates,
    onUpdateFavouriteListBadge: _onUpdateFavouriteListBadge
  };

  return hooks;
};

if (typeof ShopgateProductDetailsCore == 'object' && typeof ShopgateProductDetailsCore.registerPlugin == 'function') {
  if (ShopgateProductDetailsCore.isComponentActive('favourite_list')) {
    ShopgateProductDetailsCore.registerPlugin(favouriteListPlugin);
  }
} else {
  console.warn('No instance of "ShopgateProductDetailsCore" found');
}



// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/jquery.shopgate-product-details-favourite-list.js